import { useEffect } from "react"
import { cookies } from 'static'

export default function ExtraLivestockLogin () {

  useEffect(() => {

    const cookie = JSON.parse(localStorage.getItem(cookies.FarmersPlanToken) ?? '');

    const {username, token} = cookie;

    const params = new URLSearchParams({
      token: token,
      username: username,
    });
  
    const finalUrl = `${process.env.REACT_APP_LOGIN_PAGE_URL}?${params.toString()}`;

    window.location.href = finalUrl;

  }, [])

  return (<></>)

}